export default {
  agentInviteData: (state) => state.agentInviteData,
  recentlyViewedOpportunities: (state) => state.recentlyViewedOpportunities,
  recentlyViewedBrokerages: (state) => state.recentlyViewedBrokerages,
  recentlyViewedAgents: (state) => state.recentlyViewedAgents,
  recentlyViewedMyAgents: (state) => state.recentlyViewedMyAgents,
};
